import React from "react";
import * as S from "./styles";
export var H5 = function H5(e) {
  var t = e.children,
      r = e.className;
  return React.createElement(S.H5, {
    className: r
  }, t);
};
export default H5;